import { render, staticRenderFns } from "./WhatsappPartnerTariffs.vue?vue&type=template&id=7e1f9a19&"
import script from "./WhatsappPartnerTariffs.vue?vue&type=script&lang=ts&"
export * from "./WhatsappPartnerTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports